export default "__VITE_ASSET__BNORZ9fD__"